import Vue from 'vue';
import Router from 'vue-router';
import VueCookies from 'vue-cookies';

import mainContainer from './views/mainContainer.vue';
import loginView from './views/loginView.vue';
import signout from './components/signout.vue';
import userList from './components/users/userList.vue';
import userProfile from './components/profile/userProfile.vue';
import listPayslip from './components/payslip/listPayslip.vue';
import thirteenMonthList from './components/payslip/thirteenMonthList.vue';
import viewPayslip from './components/payslip/viewPayslip.vue';
import uploadPayslip from './components/payslip/uploadPayslip.vue';
import activateAccount from './components/users/activateAccount.vue';
import forgotPayslipPassword from './components/users/forgotPayslipPassword.vue';
import forgotPassword from './components/users/forgotPersonalPassword.vue';
import uploadReview from './components/payslip/uploadReview.vue';
import uploadThirteenMonth from './components/payslip/uploadthirteenMonth.vue';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path : '/',
            name : 'root',
            component : mainContainer,
            children : [
                {
                    path : '/signout',
                    component : signout
                },
                {
                    path : '/user/list',
                    component : userList
                },
                {
                    path : '/profile/user-profile',
                    component : userProfile
                },
                {
                    path : '/payslip/list',
                    component : listPayslip
                },
                {
                    path : '/payslip/thirteen_month/list',
                    component : thirteenMonthList
                },
                {
                    path : '/payslip/view-payslip',
                    component : viewPayslip
                },
                {
                    path : '/payslip/upload-payslip',
                    component : uploadPayslip
                },
                {
                    path : '/payslip/upload-review',
                    component : uploadReview
                },
                {
                    path : '/payslip/upload-thirteen-month',
                    component : uploadThirteenMonth
                }
            ]
        },
        {
            path : '/login',
            name : 'login',
            component : loginView
        },
        {
            path : '/activate/account',
            name : 'accountActivation',
            component : activateAccount
        },
        {
            path : '/forgot/payslip/password',
            name : 'forgotPayslipPassword',
            component : forgotPayslipPassword
        },
        {
            path : '/forgot/personal/password',
            name : 'forgotPersonalPassword',
            component : forgotPassword
        }
    ]
});


router.beforeEach((to, from, next) => {
    let cookie = VueCookies.get(cookieKey);

    if(to.name == 'accountActivation' || to.name == 'forgotPayslipPassword' || to.name == 'forgotPersonalPassword'){
        next();
    }else if(cookie == null && to.name != 'login'){
        router.push('/login');
    }else if(cookie != null && to.name == 'login'){
        router.push('/');
    }else{
        next();
    }   
});

router.afterEach((to, from) => {
    let cookie = VueCookies.get(cookieKey);
    if(cookie !== null){
        if(cookie.data.user){
            if(cookie.data.user.temp_pass.length > 0){
                router.app.openForcePassword = true;
            }
        }
    }

    if(router.app.openForcePassword){
        setTimeout(() => {
            router.app.eventHub.$emit('openForcePassword');
        }, 1000);
        
    }

    
});


export default router;